import './Icon.scss';

import { b2x } from '@b2x/react/src';

export const iconsNames = [
  'bullet',
  'quote',
  'piggy-bank',
  'info',
  'hidden',
  'visible',
  'facebook',
  'youtube',
  'twitter',
  'download',
  'drop',
  'drop-full',
  'email',
  'exit',
  'filter',
  'drop-half',
  'large-arrow-left',
  'large-arrow-right',
  'menu',
  'minus',
  'plus',
  'privacy',
  'profile',
  'return',
  'search',
  'small-arrow-down',
  'small-arrow-left',
  'small-arrow-right',
  'small-arrow-up',
  'subscribe',
  'wishlist',
  'wishlist-full',
  'attachment',
  'cart',
  'coupon',
  'credit-card',
  'customer',
  'delete',
  'trash',
  'delivery',
  'discount',
] as const;
export type IconName = (typeof iconsNames)[number];

export type IconSize = 12 | 14 | 16 | 20 | 25 | 30 | 35 | 48 | 56 | 72 | 120;

export interface IconProps extends b2x.IconProps<IconName, IconSize> {}

export const Icon = (props: IconProps) => <b2x.Icon {...props} />;

export const isIconName = (name?: string): name is IconName => b2x.isIconName(iconsNames, name);
